import { useQueryClient } from '@tanstack/react-query';
import {
  TEST_CONFIGURATION,
  TEST_OVERVIEW,
  TEST_MANAGEMENT_TESTS,
  TEST_CONDITIONAL_ALERT_DESTINATIONS,
  ALERT_RULES,
  DIGEST_RULES,
} from '@elementary/common-ui/constants/queryKeys';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';

const useInvalidateAlertsRelatedData = () => {
  const queryClient = useQueryClient();

  const envId = useSelectedEnv();

  const invalidateQueries = (testIds?: string[]) => {
    if (testIds && testIds?.length > 0) {
      testIds.forEach((testId: string) => {
        queryClient.invalidateQueries([TEST_CONFIGURATION, testId]);
        queryClient.invalidateQueries([TEST_OVERVIEW, testId, envId]);
        queryClient.invalidateQueries([
          TEST_CONDITIONAL_ALERT_DESTINATIONS,
          testId,
          envId,
        ]);
      });
    } else {
      queryClient.invalidateQueries([TEST_CONFIGURATION], { exact: false });
      queryClient.invalidateQueries([TEST_OVERVIEW], { exact: false });
      queryClient.invalidateQueries([TEST_CONDITIONAL_ALERT_DESTINATIONS], {
        exact: false,
      });
    }

    queryClient.invalidateQueries([TEST_MANAGEMENT_TESTS, envId]);
    queryClient.invalidateQueries([ALERT_RULES, envId]);
    queryClient.invalidateQueries([DIGEST_RULES, envId]);
  };

  return {
    invalidateAlertsDataQueries: invalidateQueries,
  };
};

export default useInvalidateAlertsRelatedData;
